<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <div class="flex justify-content-center mt-3" *ngIf="loading">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="w-auto mb-5">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>

            <p-tabView styleClass="tabview-custom" *ngIf="itemProdutoVw && !loading">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="pi pi-calendar mr-1"></i>
                        <span>Dados Principais</span>
                    </ng-template>

                    <div class="card-simple">
                        <div class="p-fluid p-formgrid grid">
                            <div class="col-12">
                                <div class="flex justify-content-end">
                                    <button
                                        pButton
                                        pRipple
                                        pTooltip="Calcular precificação"
                                        tooltipPosition="left"
                                        icon="pi pi-percentage"
                                        class="p-button w-full md:w-4rem"
                                        (click)="abrirDialogValorSugerido()"
                                    ></button>
                                </div>
                            </div>
                            <div class="col-12 md:col-8">
                                <div class="p-fluid p-formgrid grid">
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Descrição</label>
                                        <label class="label-inferior" id="descricao">
                                            {{ itemProdutoVw.descricao }}
                                        </label>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Fabricante</label>
                                        <label class="label-inferior" id="fabricante">
                                            {{ itemProdutoVw.descricaoFabricante }}
                                        </label>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Grupo</label>
                                        <label class="label-inferior" id="grupo">
                                            {{ itemProdutoVw.descricaoGrupo }}
                                        </label>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Valor Compra</label>
                                        <label class="label-inferior" id="valorCompra">
                                            {{ itemProdutoVw.valorCompra | currency: "BRL" }}
                                        </label>
                                    </div>

                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Valor Venda</label>
                                        <label class="label-inferior" id="valorVenda">
                                            {{ itemProdutoVw.valorVenda | currency: "BRL" }}
                                        </label>
                                    </div>
                                    <div class="field col-12 md:col-6 lg:col-4">
                                        <label class="label-superior">Lucro</label>
                                        <label class="label-inferior" id="lucro">
                                            {{ itemProdutoVw.lucro | porcentagemFormat }} |
                                            {{
                                                ((itemProdutoVw.lucro ?? 0) *
                                                    ((itemProdutoVw.valorCompra ?? 0) /
                                                        (itemProdutoVw.quantidadeUnidadeMedida ??
                                                            1))) /
                                                    100 | currency: "BRL"
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 md:col-4">
                                <div class="p-fluid p-formgrid grid">
                                    <div
                                        class="col-12 md:text-center p-2"
                                        *ngIf="itemProdutoVw.urlDetalheProduto"
                                    >
                                        <qrcode
                                            class="cursor-pointer"
                                            pTooltip="Ver dados"
                                            [qrdata]="itemProdutoVw.urlDetalheProduto"
                                            [width]="180"
                                            [errorCorrectionLevel]="'M'"
                                            (click)="abrirUrlProduto()"
                                            imageSrc="../assets/images/logo_qrcode.png"
                                        ></qrcode>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Comissão</label>
                                <label class="label-inferior" id="comissao">
                                    {{ itemProdutoVw.comissaoVenda | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Código</label>
                                <label class="label-inferior" id="codigo">
                                    {{ itemProdutoVw.codigo }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Controla Estoque</label>
                                <div class="label-inferior">
                                    <label
                                        class="product-badge status-instock"
                                        id="controlaEstoque"
                                        *ngIf="itemProdutoVw.controlaEstoque"
                                    >
                                        SIM
                                    </label>
                                    <label
                                        class="product-badge status-outofstock"
                                        id="controlaEstoque"
                                        *ngIf="!itemProdutoVw.controlaEstoque"
                                    >
                                        NÃO
                                    </label>
                                </div>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Estoque Mínimo</label>
                                <label class="label-inferior" id="estoqueMinimo">
                                    {{ itemProdutoVw.estoqueMinimo }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Estoque Máximo</label>
                                <label class="label-inferior" id="estoqueMaximo">
                                    {{ itemProdutoVw.estoqueMaximo }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Estoque Atual</label>
                                <label class="label-inferior" id="estoqueAtual">
                                    {{ itemProdutoVw.estoqueAtual }}
                                    {{ itemProdutoVw.descricaoUnidadeMedida }}
                                </label>
                            </div>

                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Qtd. UN Medida</label>
                                <label class="label-inferior" id="qtdUnidadeMedida">
                                    {{ itemProdutoVw.quantidadeUnidadeMedida }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Desc. UN Medida</label>
                                <label class="label-inferior" id="descUnidadeMedida">
                                    {{ itemProdutoVw.descricaoUnidadeMedida }}
                                </label>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Tributável</label>
                                <div class="label-inferior">
                                    <label
                                        class="product-badge status-instock"
                                        id="tributacao"
                                        *ngIf="itemProdutoVw.tributacao"
                                    >
                                        SIM
                                    </label>
                                    <label
                                        class="product-badge status-outofstock"
                                        id="tributacao"
                                        *ngIf="!itemProdutoVw.tributacao"
                                    >
                                        NÃO
                                    </label>
                                </div>
                            </div>
                            <div class="field col-12 md:col-4 lg:col-2">
                                <label class="label-superior">Ind. Esc.</label>
                                <div class="label-inferior">
                                    <label
                                        class="product-badge status-instock"
                                        id="indEscala"
                                        *ngIf="itemProdutoVw.indEscala"
                                    >
                                        SIM
                                    </label>
                                    <label
                                        class="product-badge status-outofstock"
                                        id="indEscala"
                                        *ngIf="!itemProdutoVw.indEscala"
                                    >
                                        NÃO
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="tributacao">
                    <ng-template pTemplate="header">
                        <i class="pi pi-user mr-1"></i>
                        <span>Tributação</span>
                    </ng-template>
                    <div class="card-simple">
                        <div class="p-fluid p-formgrid grid">
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">GTIN</label>
                                <label class="label-inferior" id="gtin">
                                    {{ itemProdutoVw.gtin }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">Alíquota ICMS</label>
                                <label class="label-inferior" id="aliquotaIcms">
                                    {{ itemProdutoVw.aliquotaIcms | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">Alíq. ICMS Entrada</label>
                                <label class="label-inferior" id="aliquotaIcmsEntrada">
                                    {{ itemProdutoVw.aliquotaIcmsEntrada | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">FCP</label>
                                <label class="label-inferior" id="fcp">
                                    {{ itemProdutoVw.fcp | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CST Origem</label>
                                <label class="label-inferior" id="cstOrigem">
                                    {{ itemProdutoVw.descricaoCstOrigem }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CST Tributo ICMS</label>
                                <label class="label-inferior" id="cstTributIcms">
                                    {{ itemProdutoVw.descricaoCstIcms }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CSOSN</label>
                                <label class="label-inferior" id="csosn">
                                    {{ itemProdutoVw.descricaoCsosn }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CFOP</label>
                                <label class="label-inferior" id="cfop">
                                    {{ itemProdutoVw.descricaoCfop }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CST pis</label>
                                <label class="label-inferior" id="cstpIS">
                                    {{ itemProdutoVw.descricaoCstPis }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">Alíquota PIS</label>
                                <label class="label-inferior" id="aliquotaPis">
                                    {{ itemProdutoVw.aliquotaPis | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-4">
                                <label class="label-superior">CST COFINS</label>
                                <label class="label-inferior" id="cstCofins">
                                    {{ itemProdutoVw.descricaoCstCofins }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">Alíquota COFINS</label>
                                <label class="label-inferior" id="aliquotaCofins">
                                    {{ itemProdutoVw.aliquotaCofins | porcentagemFormat }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">CEST</label>
                                <label class="label-inferior" id="cest">
                                    {{ itemProdutoVw.cest }}
                                </label>
                            </div>
                            <div class="col-12 md:col-6 xl:col-2">
                                <label class="label-superior">NCM</label>
                                <label class="label-inferior" id="ncm">
                                    {{ itemProdutoVw.ncm }}
                                </label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
            <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
                <div class="col-12 md:col-4 flex justify-content-end">
                    <button
                        type="button"
                        pButton
                        icon="pi pi-arrow-left"
                        label="Voltar"
                        class="p-button-outlined sm:w-9rem"
                        routerLink="/apps/item-produto"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog
    [(visible)]="exibirDialogValorSugerido"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '35vw' }"
    [header]="'Sugestão de preço - ' + itemProdutoVw?.descricao"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    class="p-fluid"
>
    <ng-template pTemplate="content">
        <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemProdutoVw">
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Valor Compra</label>
                <label class="block">
                    {{ itemProdutoVw.valorCompra | currency: "BRL" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Frete</label>
                <label class="block">
                    {{ percentualFrete / 100 | percent: "1.2-2" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Lucro</label>
                <label class="block">
                    {{ (itemProdutoVw.lucro ?? 0) / 100 | percent: "1.2-2" }} |
                    {{
                        ((itemProdutoVw.lucro ?? 0) * 
                        (itemProdutoVw.valorCompra ?? 0) / (itemProdutoVw.quantidadeUnidadeMedida ?? 1)) / 100
                            | currency: "BRL"
                    }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Comissão</label>
                <label class="block">
                    {{
                        itemProdutoVw.comissaoVenda
                            ? (itemProdutoVw.comissaoVenda / 100 | percent: "1.2-2")
                            : "0,00%"
                    }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Custo Fixo</label>
                <label class="block">
                    {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Custo Tributário</label>
                <label class="block">
                    {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Valor Venda</label>
                <label class="block">
                    {{ itemProdutoVw.valorVenda | currency: "BRL" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Lucro Atual</label>
                <label class="block">
                    {{ valorLucroObtidoAtual | currency: "BRL" }} |
                    {{
                        valorLucroObtidoAtual / (this.itemProdutoVw.valorVenda ?? 0)
                            | percent: "1.2-2"
                    }}
                </label>
            </div>
            <div style="width: 100%">
                <p-divider></p-divider>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Valor Sugerido</label>
                <label class="block">
                    {{ valorSugerido | currency: "BRL" }}
                </label>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Novo Valor</label>
                <p-inputNumber
                    name="novoValor"
                    ngModel
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    [allowEmpty]="true"
                    [required]="true"
                    (onInput)="calcularLucroObtido($event.value)"
                    [(ngModel)]="novoValor"
                ></p-inputNumber>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Lucro Obtido</label>
                <label class="block">
                    <span
                        class="product-badge bg-green-600 admihair-text-white"
                        *ngIf="valorLucroObtido >= 0"
                    >
                        {{ valorLucroObtido | currency: "BRL" }}
                    </span>
                    <span
                        class="product-badge bg-red-600 admihair-text-white"
                        *ngIf="valorLucroObtido < 0"
                    >
                        {{ valorLucroObtido | currency: "BRL" }}
                    </span>
                </label>
            </div>
        </div>
    </ng-template>
</p-dialog>
